import { useEffect } from 'react';
import { SelectionPageContent } from '../../components/SelectionPageContent';
import './CharacterSelection.css';
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';

export const CharacterSelection = (props: any) => {
  const parentNode = 'CHARACTER_SELECTION';
  const { __t } = useTranslation(parentNode, {
    defaultToKey: true,
  });
  const { goToPrevPage, goToNextPage } = props;
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  useEffect(() => {
    setPageTitle(__t('pageTitle'));
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  return (
    <SelectionPageContent
      parentNode={parentNode}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
    />
  );
};
